import React from "react"
import Layout from "../components/layout"
import Container from "../components/container";
import { Link } from "gatsby"

export default function Home() {
  
  
  return (
    <Layout>
      <Container>
        <p>Niels, 33 years, co-founder of Underdock Studio</p>
      </Container>
    </Layout>
  )
}